var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDirections(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63801_9637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625 5.75H9.9508C12.2362 5.75 13.3789 5.75 13.8127 6.16047C14.1877 6.51528 14.3539 7.03796 14.2526 7.54416C14.1355 8.12976 13.2026 8.78964 11.3367 10.1094L8.28829 12.2656C6.42243 13.5854 5.48949 14.2452 5.37238 14.8308C5.27114 15.337 5.43731 15.8597 5.81227 16.2145C6.24605 16.625 7.38877 16.625 9.6742 16.625H10.375M7 5.75C7 6.99264 5.99264 8 4.75 8C3.50736 8 2.5 6.99264 2.5 5.75C2.5 4.50736 3.50736 3.5 4.75 3.5C5.99264 3.5 7 4.50736 7 5.75ZM17.5 16.25C17.5 17.4926 16.4926 18.5 15.25 18.5C14.0074 18.5 13 17.4926 13 16.25C13 15.0074 14.0074 14 15.25 14C16.4926 14 17.5 15.0074 17.5 16.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63801_9637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirections);
export default __webpack_public_path__ + "static/media/icon-directions.1f2c181a7614e643e6ce2e8170f74bd6.svg";
export { ForwardRef as ReactComponent };